import { render, staticRenderFns } from "./vCheckbox.vue?vue&type=template&id=19140c9c&scoped=true"
import script from "./vCheckbox.vue?vue&type=script&lang=js"
export * from "./vCheckbox.vue?vue&type=script&lang=js"
import style0 from "./vCheckbox.vue?vue&type=style&index=0&id=19140c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19140c9c",
  null
  
)

export default component.exports